export enum JobsToBeDoneReportingEventName {
  UserEntersJobsToBeDoneReporting = 'userEntersJobsToBeDoneReporting'
}

export type JobsToBeDoneReportingEvent = {
  name: JobsToBeDoneReportingEventName.UserEntersJobsToBeDoneReporting
}
